import React, { useEffect, useState } from 'react';
import { Col, Input, List, Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '~/components/Modal';
import { RedTimes, TableView } from '~/stylizations/styles';
import { Table, TableHeader } from '~/components/Table';
import Pagination from '~/components/Pagination';
import { getStockWriteOffsItems } from '~/services/hooks/stockWriteOffsItems';
import { historyTable, lowStockHistoryTable } from '~/tables/items';
import errorHandler from '~/Utils/errorHandler';

export default function ItemView({ visible, onClose, item, isMobile }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [lowStocks, setLowStocks] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});
  const [search, setSearch] = useState('');

  const label = (text) => <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t(text)}</span>;
  const mobileLabel = (text) => (
    <div>
      <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{t(text)}</span>
    </div>
  );
  const child = (text) => {
    if (text == null || text == '') {
      return (
        <div style={{ textAlign: 'center' }}>
          <RedTimes />
        </div>
      );
    }

    return <span style={{ fontSize: isMobile ? '12px' : '15px', fontWeight: 'bold' }}>{t(`${text}`)}</span>;
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          perPage,
          search,
        },
      };
      const data = await getStockWriteOffsItems(params, `get-by-item/${item?.id}`);

      setLowStocks(data.data);
      setMeta(data.meta);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const customerFields = [
    { label: 'Nome', value: item?.name },
    {
      label: 'Peso',
      value: item?.weight,
    },
    {
      label: 'Preço de venda',
      value: item?.price,
    },
    {
      label: 'Quantidade por pacote',
      value: item?.amount_per_pack,
    },
    {
      label: 'Quantidade em estoque',
      value: item?.amount,
    },
  ];

  useEffect(() => {
    if (item && visible) {
      fetchData();
    }
  }, [item, search, page]);

  return (
    <Modal
      title={`${t('Informações')} - ${item?.name ?? ''}`}
      open={visible}
      onCancel={onClose}
      centered
      width={isMobile ? '100%' : '1200px'}
      footer={<ModalFooter showOk={false} onCancel={onClose} />}
    >
      {isMobile ? (
        <List
          bordered
          dataSource={customerFields}
          renderItem={({ label, value }) => (
            <List.Item>
              <Typography.Text strong>{mobileLabel(label)}</Typography.Text>
              {child(value)}
            </List.Item>
          )}
        />
      ) : (
        <>
          <TableView
            pagination={false}
            rowKey={() => 'basic-1'}
            bordered
            columns={[
              { title: label('Nome'), dataIndex: 'name', render: child },
              {
                title: label('Peso'),
                dataIndex: 'weight',
                render: child,
              },
            ]}
            dataSource={[item]}
          />
          <TableView
            pagination={false}
            rowKey={() => 'basic-1'}
            bordered
            columns={[
              {
                title: label('Preço de venda'),
                dataIndex: 'sale_price',
                render: child,
              },
              {
                title: label('Quantidade por pacote'),
                dataIndex: 'amount_per_pack',
                render: child,
              },
              { title: label('Quantidade em estoque'), dataIndex: 'amount', render: child },
            ]}
            dataSource={[item]}
          />
        </>
      )}
      <Typography.Title level={3} style={{ marginTop: 20 }}>
        {t('Histórico de entrada') +
          ' - ' +
          t('Média: R$ ') +
          parseFloat(item?.weighted).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
      </Typography.Title>
      <Table
        pagination={false}
        rowKey="id"
        loading={loading}
        dataSource={item?.batches_history}
        columns={historyTable(isMobile)}
        bordered
      />
      <Typography.Title level={3} style={{ marginTop: 20 }}>
        {t('Histórico de consumo') +
          ' - ' +
          t('Média: R$ ') +
          parseFloat(item?.weighted_swoi).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
      </Typography.Title>
      <Col>
        <TableHeader>
          <Input.Search
            onSearch={(value) => {
              setSearch(value);
              setPage(1);
            }}
            className="search-field"
            placeholder={t('screens:default.search')}
          />
        </TableHeader>
        <Table
          pagination={false}
          rowKey="id"
          loading={loading}
          dataSource={lowStocks}
          columns={lowStockHistoryTable(isMobile)}
          bordered
        />
        <Pagination
          isMobile={isMobile}
          onChange={(value) => {
            setPage(value);
          }}
          meta={meta}
          perPage={perPage}
          setPerPage={setPerPage}
        />
      </Col>
    </Modal>
  );
}
